import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

const apiBase = () => {
  const { hostname, port, protocol } = window.location;
  if (!port || port === '80' || port === '443') return `${protocol}//${hostname}/api/v1`;
  if (port === '3000') return `http://${hostname}:8000/api/v1`;
  return `http://${hostname}:${port}/api/v1`;
};

export default function OpenHouseAdminPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const [key, setKey] = useState(searchParams.get('key') || '');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchLeads = async (k) => {
    if (!k) return;
    setLoading(true);
    setError('');
    try {
      const r = await fetch(`${apiBase()}/openhouse/${slug}/leads?key=${encodeURIComponent(k)}`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || '無法載入');
      setData(d);
    } catch (e) {
      setError(e.message || '無法載入');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (key) fetchLeads(key);
  }, [key]);

  useEffect(() => {
    if (!key) return;
    const t = setInterval(() => fetchLeads(key), 30000);
    return () => clearInterval(t);
  }, [key]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Open House Leads</h1>

        {!key ? (
          <div style={styles.keyBox}>
            <p style={styles.note}>輸入管理金鑰以查看買家註冊名單。</p>
            <input style={styles.input} placeholder="管理金鑰（admin key）" value={key}
              onChange={e => setKey(e.target.value)} />
            <button style={styles.btn} onClick={() => fetchLeads(key)}>查看名單</button>
          </div>
        ) : (
          <>
            {data && (
              <div style={styles.header}>
                <div style={styles.sub}>{data.agent_name} · {data.address}</div>
                <div style={styles.total}>{data.total} 位買家已註冊</div>
              </div>
            )}
            {error && <div style={styles.err}>{error}</div>}
            {loading && !data && <p style={styles.note}>載入中…</p>}

            {data && data.leads && data.leads.length === 0 && (
              <p style={styles.note}>目前還沒有買家註冊。請買家掃描 QR code 到場註冊。</p>
            )}

            {data && data.leads && data.leads.map(l => (
              <div key={l.id} style={styles.lead}>
                <div style={styles.leadName}>{l.name}</div>
                <a href={`tel:${l.phone}`} style={styles.phone}>📞 {l.phone}</a>
                <a href={`mailto:${l.email}`} style={styles.email}>✉️ {l.email}</a>
                <div style={styles.time}>{new Date(l.created_at).toLocaleString('en-US')}</div>
              </div>
            ))}

            {data && (
              <div style={styles.actions}>
                <a href={`${apiBase()}/openhouse/${slug}/leads/csv?key=${encodeURIComponent(key)}`} style={styles.btnLink} download>下載 CSV</a>
                <button style={styles.btnGhost} onClick={() => fetchLeads(key)}>重新整理</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f4f5f7', fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif', padding: 16 },
  card: { maxWidth: 560, margin: '0 auto', background: '#fff', borderRadius: 16, padding: 20, boxShadow: '0 2px 16px rgba(0,0,0,.08)' },
  h1: { fontSize: 20, fontWeight: 800, color: '#0f172a', margin: '0 0 14px' },
  keyBox: { display: 'flex', flexDirection: 'column', gap: 10 },
  input: { width: '100%', boxSizing: 'border-box', padding: '12px 14px', fontSize: 15, borderRadius: 10, border: '1px solid #cbd5e1', outline: 'none' },
  btn: { padding: '12px', fontSize: 15, fontWeight: 700, color: '#fff', background: '#0e7a5f', border: 'none', borderRadius: 12, cursor: 'pointer' },
  btnGhost: { padding: '10px 14px', fontSize: 14, fontWeight: 600, color: '#0e7a5f', background: '#fff', border: '1px solid #0e7a5f', borderRadius: 10, cursor: 'pointer' },
  btnLink: { padding: '10px 14px', fontSize: 14, fontWeight: 600, color: '#fff', background: '#0e7a5f', borderRadius: 10, textDecoration: 'none' },
  note: { fontSize: 14, color: '#64748b', lineHeight: 1.6 },
  err: { color: '#dc2626', fontSize: 14, margin: '10px 0' },
  header: { marginBottom: 14 },
  sub: { fontSize: 14, color: '#334155', fontWeight: 600 },
  total: { fontSize: 13, color: '#0e7a5f', fontWeight: 700, marginTop: 4 },
  lead: { border: '1px solid #e2e8f0', borderRadius: 12, padding: 14, marginBottom: 10 },
  leadName: { fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 6 },
  phone: { display: 'block', fontSize: 16, fontWeight: 700, color: '#0e7a5f', textDecoration: 'none', marginBottom: 4 },
  email: { display: 'block', fontSize: 14, color: '#334155', textDecoration: 'none', marginBottom: 4 },
  time: { fontSize: 12, color: '#94a3b8' },
  actions: { display: 'flex', gap: 10, marginTop: 14 },
};
